import { showAddonDetailByVersion, showAvailableAddonDetail } from '@/apis/addons';
import { Col, Collapse, Divider, Row, Select, Spin, Typography } from 'antd';  
import TextArea from 'antd/es/input/TextArea';
import { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx'
import { useResourceContext } from "@/layouts/ResourceContext";

import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-yaml';
import 'ace-builds/src-noconflict/theme-monokai';

export const ConfigureAddon = ({addon, updateAddon, panelOpen}) => {

  const { Option } = Select;
  const { Title, Paragraph } = Typography;
  const { Panel } = Collapse;
  const { state, dispatch } = useResourceContext();
  const { selectedResources: [selectedInstance] } = state;
  const [ config, setConfig ] = useState(null);
  const [ versions, setVersions] = useState([]);
  const [ version, setVersion ] = useState("");
  const [ isLoading, setIsLoading] = useState(false);
  const [sampleHeight, setSampleHeight] = useState(0);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await showAvailableAddonDetail(addon.id);
      if(response.status == "OK") {
        const res = response.value;
        let versions = res.versions;
        if(versions) {
          // no platforms (helm, infra addons) means any platform; a module lists its own, e.g. "6.1,7.1"
          versions = versions.filter(version => !version.platforms ||
            version.platforms.split(',').map(p => p.trim()).includes(selectedInstance.platform));
          setVersions(versions);
        }
        const ver = addon.version? addon.version : versions && versions.length ? versions[0].version : "";
        updateAddon({...res, version: ver, config: addon.config || ""}, addon.version != ver);
        if(ver) {
          setVersion(ver);
          fetchVersionData(ver);
        }
      }
    } catch (error) {
      console.error(`Error fetching data for addon ${addon.id}:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchVersionData = async (version) => {
    try {
      const response = await showAddonDetailByVersion(addon.id, version);
      if(response.status == "OK") {
        setConfig(response.value.values || "");
      }
    } catch (error) {
      console.error(`Error fetching data for version ${version}:`, error);
    }
  };

  const onVersionChange = (e) => {
    fetchVersionData(e);
    addon.version = e;
    updateAddon(addon, true);
  }

  const onConfigChange = (e) => {
    addon.config = e;
    updateAddon(addon, true);
  }

  useEffect(() => {
    fetchData();
    setSampleHeight(parseInt(window.innerHeight/2));
    const handleResize = () => {
      setSampleHeight(parseInt(window.innerHeight/2));
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])

  const options = {
    overrides: {
      h1: {
        component: 'h1',
        props: {
          className: 'custom-header',
        },
      },
      pre: {
        component: 'pre',
        props: {
          style: {
            backgroundColor: '#f0f0f0',
            padding: '10px',
            borderRadius: '5px',
            fontSize: '14px',
            overflowX: 'auto',
          },
        },
      }
    },
  };


  return (
    <div style={{ height: '100%', width: '100%' }}>
      <Title level={2}>{addon.name}</Title>
      <Divider style={{margin: '10px'}}/>
      <Row type="flex" justify="space-between" align='middle' style={{ height: '18vh', width: '100%' }}>
        <Col span={2} >
          <div style={{ display: 'grid', gridTemplateRows: '1fr 2fr', height: '100%' }}>
            <h3>Listed By</h3>
            <div style={{ backgroundImage: 'url(../../../../vitria.svg)', width: '100%', height: '100%', backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }}></div>
          </div>
        </Col>
        <Divider type="vertical" style={{ height: '60%', margin: 0 }} />
        <Col span={2} align='middle'>
          <div style={{ display: 'grid', gridTemplateRows: '1fr 2fr', height: '100%' }}>
            <h3>Category</h3>
            {addon.category && <div><strong>{addon.category}</strong></div>}
          </div>
        </Col>
        <Divider type="vertical" style={{ height: '60%', margin: 0 }} />
        <Col span={2} align='middle'>
          <div style={{ display: 'grid', gridTemplateRows: '1fr 2fr', height: '100%' }}>
            <h3>Status</h3>
            <div><strong>Ready to install</strong></div>
          </div>
        </Col>
        <Divider type="vertical" style={{ height: '60%', margin: 0 }} />
        <Col span={8}>
          <div style={{ display: 'grid', gridTemplateRows: '1fr 2fr', height: '100%' }}>
            <h3>Version</h3>
            {<Select style={{ width: 200 }} value={addon.version || version} onChange={(e) => onVersionChange(e)} >{
              versions.map((version) => (
                <Option value={version.version}>{version.version}</Option>
              ))}
            </Select>}
          </div>
        </Col>
      </Row>
      <Collapse 
        bordered={false}
        defaultActiveKey={panelOpen ? ['1'] : []}
      >
        <Panel header="Optional configuration settings" key="1">
          <Paragraph>Add-on configuration example</Paragraph>
          {config == null && <Spin size="large" />}
          {config !== null && <div style={{border: 'lightgray 1px solid', borderRadius: '5px', padding: '10px', maxHeight: {sampleHeight},overflowY: 'auto'}}><Markdown options={options}>{config}</Markdown></div>}
          <Paragraph>Configuration values</Paragraph>
          {/* <TextArea rows={8} onChange={(e) => onConfigChange(e)} value={addon.config}/> */}
          <AceEditor
            mode="yaml"
            theme="github"
            name="yaml-editor"
            fontSize={14}
            showPrintMargin={false}
            showGutter={true}
            highlightActiveLine={true}
            value={addon.config}
            onChange={onConfigChange}
            setOptions={{
              enableBasicAutocompletion: true,
              enableLiveAutocompletion: true,
              enableSnippets: true,
              tabSize: 2,
            }}
            width="100%"
            height="300px"
          />
        </Panel>
      </Collapse>
    </div>
  );
}